import Select from "@material-ui/core/Select/Select"
import MenuItem from "@material-ui/core/MenuItem/MenuItem"
import { letters } from "../../../../courseSettings/CourseSettingsSteps/questionForm/MatchingQuestionConstructor"

const MatchingQuestion = ({
  question: { title, questions = [], answers = [], user_answer_options = [] },
  onChange,
  isCompleted,
  questionIdx,
}) => {
  return (
    <div className="full-width" key={questionIdx}>
      <div className="form__fieldset">
        <span className="form__label">Question {questionIdx + 1}</span>
        <div className="form__fieldbox">
          <div className="form__masked-value">{title}</div>
        </div>
      </div>

      <div className="form__fieldset">
        <span className="form__label">Statements</span>
        <div className="form__fieldbox">
          <div className="form__masked-value">
            {questions.map((q, statementIndex) => (
              <div
                className={statementIndex < questions.length - 1 ? "mb8" : ""}
                key={`statement-${statementIndex}`}
              >
                <span>
                  {statementIndex + 1}. {q.value}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="form__fieldset">
        <span className="form__label">Options</span>
        <div className="form__fieldbox">
          <div className="form__masked-value">
            {answers.map((a, optionIndex) => (
              <div
                className={optionIndex < answers.length - 1 ? "mb8" : ""}
                key={`option-${optionIndex}`}
              >
                <span>
                  {letters[optionIndex]}. {a.value}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="form__fieldset">
        <label htmlFor="answer" className="form__label f aic">
          Right answers *
        </label>
        <div className="form__fieldbox">
          {questions.map((item, answerIndex) => (
            <div className="f aib mb20" key={answerIndex}>
              <span className={"mr5"}>{answerIndex + 1}: </span>
              <Select
                id={"right-answer-" + answerIndex}
                name={"rightAnswer_" + answerIndex}
                fullWidth
                displayEmpty
                value={user_answer_options[answerIndex]}
                onChange={(e) => onChange(e, questionIdx, answerIndex)}
                style={{ width: 300 }}
                renderValue={(value) => {
                  if (!Number.isInteger(value)) {
                    return <span className="color-black-38">Select answer</span>
                  }

                  return letters[value]
                }}
                disabled={isCompleted}
              >
                <MenuItem value={""}>
                  <span className={"color-black-38"}>Select answer</span>
                </MenuItem>
                {answers.map((item, answerOptionIndex) => (
                  <MenuItem
                    value={answerOptionIndex}
                    key={letters[answerOptionIndex]}
                  >
                    {letters[answerOptionIndex]}
                  </MenuItem>
                ))}
              </Select>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default MatchingQuestion
